var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArmaturaDublaWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bb244d7f-c945-4b40-b7eb-12475f1e39af",
    "data-name": "armatura",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b3127ee4-8aa2-4a29-9de9-4a13235f9876,.e1f9024e-fe9c-4c6c-aa40-2680762f700a{fill:none;}.b69d0b12-9fef-475c-b9ff-e2d50c2f23a9{clip-path:url(#beae785b-b186-408f-9520-0917ca90e3ab);}.a89b5126-e0f9-4443-9da0-6fddedbbe0b9{fill:#fff;}.e1f9024e-fe9c-4c6c-aa40-2680762f700a{stroke:#fff;stroke-miterlimit:10;stroke-width:8px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "beae785b-b186-408f-9520-0917ca90e3ab",
    transform: "translate(0 37)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b3127ee4-8aa2-4a29-9de9-4a13235f9876",
    width: 200,
    height: 200
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "armatura_dubla_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b69d0b12-9fef-475c-b9ff-e2d50c2f23a9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a89b5126-e0f9-4443-9da0-6fddedbbe0b9",
    d: "M190-25.15v209.3a4,4,0,0,1-4,4H14a4,4,0,0,1-4-4V-21.15a4,4,0,0,1,4-4H190M200-33a4,4,0,0,0-4-4H4a4,4,0,0,0-4,4V196a4,4,0,0,0,4,4H196a4,4,0,0,0,4-4Z",
    transform: "translate(0 37)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e1f9024e-fe9c-4c6c-aa40-2680762f700a",
    x: 40,
    y: 5.01,
    width: 120,
    height: 190.4,
    rx: 8
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmaturaDublaWhite);
export default __webpack_public_path__ + "static/media/armatura_dubla_white.35b962fc66c73112f6ea97ca6110bdd8.svg";
export { ForwardRef as ReactComponent };